import OnboardingFlowRoutes from './routes.js'
import PlaybookFlowRoutes from './OnboardingPlaybookFlow/routes.js'
import DemoRequestPlaybookFlowRoutes from './OnboardingDemoRequestPlaybookFlow/routes.js'
import BotFlowRoutes from './OnboardingBotFlow/routes.js'
import { length } from 'ramda'


export const ONBOARDING_STEP_COUNT = length(OnboardingFlowRoutes)
export const PLAYBOOK_STEP_COUNT = length(PlaybookFlowRoutes)
export const DEMO_REQUEST_STEP_COUNT = length(DemoRequestPlaybookFlowRoutes)
export const BOT_STEP_COUNT = length(BotFlowRoutes)

export const STEP_COUNT_TOTAL = ONBOARDING_STEP_COUNT + PLAYBOOK_STEP_COUNT + DEMO_REQUEST_STEP_COUNT + BOT_STEP_COUNT


// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/constants.js